import Vue from 'vue'
import Router from 'vue-router'
import {tool} from './common/js/tool.js';

import Home from './containers/home/home.vue';
import NotFound from './containers/home/404.vue';
import Login from './containers/home/login.vue';
import PageBase from './containers/page/base.vue';
import PageBaseMock from './containers/page/base-mock.vue';
import Design from './containers/design/index.vue';

Vue.use(Router);

let routes = [
  {
    path: '*',
    component: NotFound
  },
  {
    path: '/login',
    name: '登录',
    component: Login
  },
  {
    path: '/',
    name: '欢迎',
    component: PageBase,
    // redirect: '/monitoring/realtime',
    redirect: '/login',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home
      },
    ]
  },
  {
    path: '/monitoring-mock',
    name: '实时监控 ',
    component: PageBaseMock,
    redirect: '/monitoring-mock/realtime',
    children: [
      {
        path: 'realtime',
        name: '人员实时显示-mock',
        component: () => import(/* webpackChunkName: "monitoring-realtime-mock" */ './containers/monitoring/realtime-mock.vue')
      },
    ]
  },
  {
    path: '/monitoring',
    name: '实时监控  ',
    component: PageBase,
    redirect: '/monitoring/realtime',
    children: [
      {
        path: 'realtime',
        name: '人员实时显示',
        component: () => import(/* webpackChunkName: "monitoring-realtime" */ './containers/monitoring/realtime.vue')
      },

      {
        path: 'realtime-manage',
        name: '管理人员实时分布',
        component: () => import(/* webpackChunkName: "monitoring-realtime-manage" */ './containers/monitoring/realtime-manage.vue')
      },
      {
        path: 'area',
        name: '按区域人员显示',
        component: () => import(/* webpackChunkName: "monitoring-area" */ './containers/monitoring/area.vue')
      },
      {
        path: 'install-site',
        name: '按安装地点显示',
        component: () => import(/* webpackChunkName: "monitoring-install-site" */ './containers/monitoring/install-site.vue')
      },
      {
        path: 'cabin',
        name: '按船舱总段显示',
        component: () => import(/* webpackChunkName: "monitoring-cabin" */ './containers/monitoring/cabin.vue')
      },
      {
        path: 'facility-status',
        name: '设备工作状态显示',
        component: () => import(/* webpackChunkName: "monitoring-facility-status" */ './containers/monitoring/facility-status.vue')
      },
      {
        path: 'video-tracking',
        name: '视频追踪',
        component: () => import(/* webpackChunkName: "monitoring-video-tracking" */ './containers/monitoring/video-tracking.vue')
      }
    ]
  },

  {
    path: '/search',
    name: '实时监控',
    component: PageBase,
    redirect: '/search/tracked',
    children: [
      {
        path: 'tracked',
        name: '历史轨迹回放',
        component: () => import(/* webpackChunkName: "search-tracked" */ './containers/search/tracked.vue')
      },
      {
        path: 'tracked-mock',
        name: '历史轨迹回放2',
        component: () => import(/* webpackChunkName: "search-tracked-mock" */ './containers/search/tracked-mock.vue')
      },
      {
        path: 'person-in-out',
        name: '出入人口统计',
        component: () => import(/* webpackChunkName: "search-person-in-out" */ './containers/search/person-in-out.vue')
      },
      {
        path: 'area-in-out',
        name: '进出区域信息查询',
        component: () => import(/* webpackChunkName: "search-area-in-out" */ './containers/search/area-in-out.vue')
      },
      {
        path: 'card-in-out',
        name: '发退卡信息查询',
        component: () => import(/* webpackChunkName: "search-card-in-out" */ './containers/search/card-in-out.vue')
      },
      {
        path: 'tracking',
        name: '当前位置列表',
        component: () => import(/* webpackChunkName: "search-tracking" */ './containers/search/tracking.vue')
      },
      {
        path: 'tracked-list',
        name: '历史轨迹列表',
        component: () => import(/* webpackChunkName: "search-tracked-list" */ './containers/search/tracked-list.vue')
      },
      {
        path: 'person-info',
        name: '人员信息查询',
        component: () => import(/* webpackChunkName: "search-person-info" */ './containers/search/person-info.vue')
      },
      {
        path: 'person-bind',
        name: '人员绑定查询',
        component: () => import(/* webpackChunkName: "search-person-bind" */ './containers/search/person-bind.vue')
      },
      {
        path: 'person-binded',
        name: '未解绑人员查询',
        component: () => import(/* webpackChunkName: "search-person-binded" */ './containers/search/person-binded.vue')
      },
    ]
  },

  {
    path: '/data',
    name: '数据报表',
    component: PageBase,
    redirect: '/data/person-hour',
    children: [
      {
        name: '人员工时统计',
        path: 'person-hour',
        component: () => import(/* webpackChunkName: "data-person-hour" */ './containers/data/person-hour.vue')
      },
      {
        name: '日考勤',
        path: 'attendance',
        component: () => import(/* webpackChunkName: "data-attendance" */ './containers/data/attendance.vue')
      },
      {
        name: '月末统计',
        path: 'month-statistics',
        component: () => import(/* webpackChunkName: "data-month-statistics" */ './containers/data/month-statistics.vue')
      },
      {
        name: '人员信息报表',
        path: 'person-info',
        component: () => import(/* webpackChunkName: "data-person-info" */ './containers/data/person-info.vue')
      },
      {
        name: '人员分布报表',
        path: 'pi1-person-distribution',
        component: () => import(/* webpackChunkName: "data-pi1-person-distribution" */ './containers/data/pi1-person-distribution.vue')
      },
      {
        name: '轨迹报表',
        path: 'pi2-person-track',
        component: () => import(/* webpackChunkName: "data-pi2-person-track" */ './containers/data/pi2-person-track.vue')
      },
      {
        name: '出入统计',
        path: 'pi3-in-out',
        component: () => import(/* webpackChunkName: "data-pi3-in-out" */ './containers/data/pi3-in-out.vue')
      },
      {
        name: '人员报警记录',
        path: 'pi4-person-warning',
        component: () => import(/* webpackChunkName: "data-pi4-person-warning" */ './containers/data/pi4-person-warning.vue')
      },
      {
        name: '滞留人员清单',
        path: 'pi5-person-retention',
        component: () => import(/* webpackChunkName: "data-pi5-person-retention" */ './containers/data/pi5-person-retention.vue')
      },
      {
        name: '工种人数统计',
        path: 'pi6-work-type',
        component: () => import(/* webpackChunkName: "data-pi6-work-type" */ './containers/data/pi6-work-type.vue')
      },
      {
        name: '部门人数汇总',
        path: 'pi7-department-count',
        component: () => import(/* webpackChunkName: "data-pi7-department-count" */ './containers/data/pi7-department-count.vue')
      },
      {
        name: '人员报警查询',
        path: 'ws1-person-warning',
        component: () => import(/* webpackChunkName: "data-ws1-person-warning" */ './containers/data/ws1-person-warning.vue')
      },
      {
        name: '工作超时报警',
        path: 'ws2-work-timeout',
        component: () => import(/* webpackChunkName: "data-ws2-work-timeout" */ './containers/data/ws2-work-timeout.vue')
      },
      {
        name: '区域超员告警',
        path: 'ws3-area-full-people',
        component: () => import(/* webpackChunkName: "data-ws3-area-full-people" */ './containers/data/ws3-area-full-people.vue')
      },
      {
        name: '禁入区域告警',
        path: 'ws4-restricted-warning',
        component: () => import(/* webpackChunkName: "data-ws4-restricted-warning" */ './containers/data/ws4-restricted-warning.vue')
      },
      {
        name: '工种冲突报警',
        path: 'ws5-work-type-repeat',
        component: () => import(/* webpackChunkName: "data-ws5-work-type-repeat" */ './containers/data/ws5-work-type-repeat.vue')
      },
      {
        name: '人员静止查询',
        path: 'ws6-person-static',
        component: () => import(/* webpackChunkName: "data-ws6-person-static" */ './containers/data/ws6-person-static.vue')
      },
      {
        name: '基站电压低',
        path: 'ws7-station-voltage-low',
        component: () => import(/* webpackChunkName: "data-ws7-station-voltage-low" */ './containers/data/ws7-station-voltage-low.vue')
      },
      {
        name: '基站不在线',
        path: 'ws8-station-offline',
        component: () => import(/* webpackChunkName: "data-ws8-station-offline" */ './containers/data/ws8-station-offline.vue')
      },
      {
        name: '卡电压低告警',
        path: 'ws9-card-voltage-low',
        component: () => import(/* webpackChunkName: "data-ws9-card-voltage-low" */ './containers/data/ws9-card-voltage-low.vue')
      },
      {
        name: '传感器报警',
        path: 'ws10-sensor-warning',
        component: () => import(/* webpackChunkName: "data-ws10-sensor-warning" */ './containers/data/ws10-sensor-warning.vue')
      },
      {
        name: '设备系统日志',
        path: 'device-log',
        component: () => import(/* webpackChunkName: "data-device-log" */ './containers/data/device-log.vue')
      },
    ]
  },

  {
    path: '/device',
    name: '设备查询',
    component: PageBase,
    redirect: '/device/sub-station',
    children: [
      {
        path: 'sub-station',
        name: '分站查询',
        component: () => import(/* webpackChunkName: "device-sub-station" */ './containers/device/sub-station.vue')
      },
      {
        path: 'base-station',
        name: '基站查询',
        component: () => import(/* webpackChunkName: "device-base-station" */ './containers/device/base-station.vue')
      },
      {
        path: 'sensor',
        name: '传感器查询',
        component: () => import(/* webpackChunkName: "device-sensor" */ './containers/device/sensor.vue')
      },
      {
        path: 'siren',
        name: '声光报警器查询',
        component: () => import(/* webpackChunkName: "device-siren" */ './containers/device/siren.vue')
      },
      {
        path: 'trumpet',
        name: '喇叭查询',
        component: () => import(/* webpackChunkName: "device-trumpet" */ './containers/device/trumpet.vue')
      },
    ]
  },

  {
    path: '/warning',
    name: '紧急告警',
    component: PageBase,
    redirect: '/warning/sub-station',
    children: [
      {
        path: 'base-station',
        name: '按基站发送',
        component: () => import(/* webpackChunkName: "warning-base-station" */ './containers/warning/base-station.vue')
      },
      {
        path: 'deck',
        name: '按甲板发送',
        component: () => import(/* webpackChunkName: "warning-deck" */ './containers/warning/deck.vue')
      },
      {
        path: 'area',
        name: '按区域发送',
        component: () => import(/* webpackChunkName: "warning-area" */ './containers/warning/area.vue')
      },
      {
        path: 'person',
        name: '按人员发送',
        component: () => import(/* webpackChunkName: "warning-person" */ './containers/warning/person.vue')
      },
    ]
  },

  {
    path: '/system',
    name: '系统设置',
    component: PageBase,
    redirect: '/system/auth',
    children: [
      {
        path: 'auth',
        name: '权限设置',
        component: () => import(/* webpackChunkName: "system-auth" */ './containers/system/auth.vue')
      },
      {
        path: 'role',
        name: '角色管理',
        component: () => import(/* webpackChunkName: "system-role" */ './containers/system/role.vue')
      },
      {
        path: 'user',
        name: '用户管理',
        component: () => import(/* webpackChunkName: "system-user" */ './containers/system/user.vue')
      },
    ]
  },

  {
    path: '/params',
    name: '参数设置',
    component: PageBase,
    redirect: '/params/base-station',
    children: [
      {
        path: 'base-station',
        name: '基站管理',
        component: () => import(/* webpackChunkName: "params-base-station" */ './containers/params/base-station.vue')
      },
      {
        path: 'passage',
        name: '过道管理',
        component: () => import(/* webpackChunkName: "params-passage" */ './containers/params/passage.vue')
      },
      {
        path: 'deck-connect-passage',
        name: '连接同甲板过道',
        component: () => import(/* webpackChunkName: "params-deck-connect-passage" */ './containers/params/deck-connect-passage.vue')
      },
      {
        path: 'stair',
        name: '楼梯管理',
        component: () => import(/* webpackChunkName: "params-stair" */ './containers/params/stair.vue')
      },
      {
        path: 'ship',
        name: '整船平面图',
        component: () => import(/* webpackChunkName: "params-ship" */ './containers/params/ship.vue')
      },
      {
        path: 'cabin',
        name: '舱室管理',
        component: () => import(/* webpackChunkName: "params-cabin" */ './containers/params/cabin.vue')
      },
      {
        path: 'deck',
        name: '甲板管理',
        component: () => import(/* webpackChunkName: "params-deck" */ './containers/params/deck.vue')
      },
      {
        path: 'area',
        name: '区域管理',
        component: () => import(/* webpackChunkName: "params-area" */ './containers/params/area.vue')
      },
      {
        path: 'sub-station-install',
        name: '分站安装地点',
        component: () => import(/* webpackChunkName: "params-sub-station-install" */ './containers/params/sub-station-install.vue')
      },
      {
        path: 'work-type-conflict',
        name: '工种冲突设置',
        component: () => import(/* webpackChunkName: "params-work-type-conflict" */ './containers/params/work-type-conflict.vue')
      },
      {
        path: 'person-info',
        name: '人员信息管理',
        component: () => import(/* webpackChunkName: "params-person-info" */ './containers/params/person-info.vue')
      },
      {
        path: 'admin-set',
        name: '管理人员设置',
        component: () => import(/* webpackChunkName: "params-admin-set" */ './containers/params/admin-set.vue')
      },
      {
        path: 'cabin-master',
        name: '船舱总段管理',
        component: () => import(/* webpackChunkName: "params-cabin-master" */ './containers/params/cabin-master.vue')
      },
      {
        path: 'base-station-distribution',
        name: '基站分布',
        component: () => import(/* webpackChunkName: "params-base-station-distribution" */ './containers/params/base-station-distribution.vue')
      },
      {
        path: 'area-authorization',
        name: '区域授权',
        component: () => import(/* webpackChunkName: "params-area-authorization" */ './containers/params/area-authorization.vue')
      },
      {
        path: 'camera',
        name: '摄像机管理',
        component: () => import(/* webpackChunkName: "params-camera" */ './containers/params/camera.vue')
      },
      {
        path: 'horn',
        name: '喇叭管理',
        component: () => import(/* webpackChunkName: "params-horn" */ './containers/params/horn.vue')
      },
      {
        path: 'sensor',
        name: '传感器管理',
        component: () => import(/* webpackChunkName: "params-sensor" */ './containers/params/sensor.vue')
      },
      {
        path: 'siren',
        name: '声光报警器管理',
        component: () => import(/* webpackChunkName: "params-siren" */ './containers/params/siren.vue')
      },
      {
        path: 'voice',
        name: '语音文件管理',
        component: () => import(/* webpackChunkName: "params-voice" */ './containers/params/voice.vue')
      },
      {
        path: 'sub-station',
        name: '分站管理',
        component: () => import(/* webpackChunkName: "params-sub-station" */ './containers/params/sub-station.vue')
      },
    ]
  },

  {
    path: '/radio',
    name: '应急广播',
    component: PageBase,
    redirect: '/radio/warning-set',
    children: [
      {
        path: 'warning-set',
        name: '应急广播设置',
        component: () => import(/* webpackChunkName: "radio-warning-set" */ './containers/radio/warning-set.vue')
      },
      {
        path: 'area',
        name: '按区域广播',
        component: () => import(/* webpackChunkName: "radio-area" */ './containers/radio/area.vue')
      },
      {
        path: 'sub-station',
        name: '按分站广播',
        component: () => import(/* webpackChunkName: "radio-sub-station" */ './containers/radio/sub-station.vue')
      },
      {
        path: 'all-ship',
        name: '全船广播',
        component: () => import(/* webpackChunkName: "radio-all-ship" */ './containers/radio/all-ship.vue')
      },
      {
        path: 'voice',
        name: '语音呼叫',
        component: () => import(/* webpackChunkName: "radio-voice" */ './containers/radio/voice.vue')
      }
    ]
  },

  {
    path: '/design',
    name: '页面设计中',
    redirect: '/design/page1',
    component: Design,
    children: [
      {
        path: 'page1',
        name: 'design-page1',
        component: () => import(/* webpackChunkName: "design-page1" */ './containers/design/page1.vue')
      },
      {
        path: 'page2',
        component: () => import(/* webpackChunkName: "design-page2" */ './containers/design/page2.vue')
      },
      {
        path: 'page3',
        component: () => import(/* webpackChunkName: "design-page3" */ './containers/design/page3.vue')
      },
      {
        path: 'page4',
        component: () => import(/* webpackChunkName: "design-page4" */ './containers/design/page4.vue')
      },
      {
        path: 'page5',
        component: () => import(/* webpackChunkName: "design-page5" */ './containers/design/page5.vue')
      },
      {
        path: 'page6',
        component: () => import(/* webpackChunkName: "design-page6" */ './containers/design/page6.vue')
      },
      {
        path: 'page7',
        component: () => import(/* webpackChunkName: "design-page7" */ './containers/design/page7.vue')
      },
      {
        path: 'page8',
        component: () => import(/* webpackChunkName: "design-page8" */ './containers/design/page8.vue')
      },
      {
        path: 'page9',
        component: () => import(/* webpackChunkName: "design-page9" */ './containers/design/page9.vue')
      },
      {
        path: 'page10',
        component: () => import(/* webpackChunkName: "design-page10" */ './containers/design/page10.vue')
      },
      {
        path: 'hold',
        name: 'Hold',
        component: () => import(/* webpackChunkName: "hold" */ './containers/design/hold.vue')
      },
      {
        path: 'test0',
        name: 'Test0',
        component: () => import(/* webpackChunkName: "test0" */ './containers/design/test.vue')
      },
      {
        path: 'test1',
        name: 'Test1',
        meta: {
          requireAuth: true
        },
        component: () => import(/* webpackChunkName: "test1" */ './containers/design/test1.vue')
      },
      {
        path: 'test2',
        name: 'Test2',
        meta: {
          requireAuth: true
        },
        component: () => import(/* webpackChunkName: "test2" */ './containers/design/test2.vue')
      },
    ]
  },

  {
    path: '/test',
    name: '测试页面',
    component: PageBase,
    redirect: '/test/polygon',
    children: [
      {
        path: 'polygon',
        name: 'js使用canvas绘制多边形',
        component: () => import(/* webpackChunkName: "test-polygon" */ './containers/test/polygon.vue')
      },
      {
        path: 'move',
        name: 'move',
        component: () => import(/* webpackChunkName: "test-move" */ './containers/test/move.vue')
      },
      {
        path: 'svg-line-animation',
        name: 'svg-line-animation',
        component: () => import(/* webpackChunkName: "test-svg-line-animation" */ './containers/test/svg-line-animation.vue')
      }
    ]
  },


  // {
  //   path: '/',
  //   name: '欢迎',
  //   component: Container,
  //   redirect: '/home',
  //   children: [
  //     {
  //       path: '*',
  //       component: Home
  //     },

  //   ]
  // },
];

// // 尝试批量设置路由，失败
// let openRoutes = {
//   path: '/openlayers',
//   name: 'openlayers',
//   component: Container,
//   redirect: '/openlayers/01',
//   children: []
// };
// for (let i = 1; i < 100; i++) {
//   openRoutes.children.push({
//     path: tool.ddigit(i).toString(),
//     name: 'openlayers-' + tool.ddigit(i),
//     component: () => import( './containers/openlayers/' + tool.ddigit(i) + '.vue')
//     // component: (resolve) => {
//     //   import(`./containers/openlayers/${tool.ddigit(i)}.vue`).then((module) => {
//     //     resolve(module);
//     //   })
//     // }
//     // component: resolve => require(['./containers/openlayers/' + tool.ddigit(i) + '.vue'], resolve)//将组件用require引进来
//   })
// }
// routes.push(openRoutes);
// console.log(JSON.stringify(routes));

export default new Router({
  routes: routes
})

